// src/views/SdkDocView.tsx
import React, { useEffect, useState } from 'react';
import { Spin, Alert } from 'antd';
import MarkdownRenderer from '../components/MarkdownRenderer';
import { sdkMgmt } from '../server/SdkMgmt';

const SdkDocView: React.FC = () => {
    const [content, setContent] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    // 检测是否为移动设备
    const isMobile = window.innerWidth <= 768;
    const [isMobileState, setIsMobileState] = useState(isMobile);

    useEffect(() => {
        const fetchDoc = async () => {
            // let downloadUrl = localStorage.getItem('doc_download_url');
            // 从API获取
            const response = await sdkMgmt.getDownloadInfo();

            let downloadUrl = null;
            if (response && response.success) {
                const data = response.data;
                downloadUrl = data.docDownloadInfo.downloadUrl;
            }
            if (!downloadUrl) {
                // const docName = `SdkDoc_v0.0.1.md`;
                // downloadUrl = `https://ctrl.healthassistant.app/sdk/doc/${docName}`
                downloadUrl = `https://ctrl.healthassistant.app/sdk/20260905_103300/ECG_SDK_User_Guide_EN.md`;
            }
            try {
                const response = await fetch(downloadUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const text = await response.text();
                setContent(text);
            } catch (err: any) {
                setError(err.message || '加载文档失败');
            } finally {
                setLoading(false);
            }
        };

        fetchDoc();

        // 监听窗口大小变化
        const handleResize = () => {
            setIsMobileState(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Spin size="large" tip="加载文档中..." />
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ padding: '24px' }}>
                <Alert message="加载失败" description={error} type="error" showIcon />
            </div>
        );
    }

    // 移动端完全全屏，不留边距
    const containerStyle = isMobileState ? {
        padding: '0',  // 完全去掉内边距
        maxWidth: '100%',
        margin: 0,
        width: '100%',  // 强制100%宽度
    } : {
        padding: '24px',
        maxWidth: '900px',
        margin: '0 auto',
    };

    const contentStyle = isMobileState ? {
        background: '#fff',
        padding: '16px 20px',  // 只保留少量左右内边距，保证文字不贴边
        borderRadius: 0,
        boxShadow: 'none',
        width: '100%',  // 强制100%宽度
        minHeight: '100vh',  // 确保覆盖全屏高度
    } : {
        background: '#fff',
        padding: '24px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    };

    return (
        <div style={containerStyle}>
            <div style={contentStyle}>
                <MarkdownRenderer content={content} />
            </div>
        </div>
    );
};

export default SdkDocView;